import { createContext, useContext } from 'react';

import { BoxProps } from '@eneco/sparky/types';

import { ColumnAlignment, ColumnArrangement } from './SplitView';

interface Props {
  columnArrangement?: ColumnArrangement;
  columnAlignment?: ColumnAlignment;
  backgroundFirst?: BoxProps['backgroundColor'];
  backgroundSecond?: BoxProps['backgroundColor'];
  hasOverlap?: boolean;
}

export const SplitViewContext = createContext<Props>({
  columnArrangement: undefined,
  columnAlignment: undefined,
  backgroundFirst: undefined,
  backgroundSecond: undefined,
  hasOverlap: undefined,
});

export const useSplitView = () => {
  return useContext(SplitViewContext);
};
